define(['modules/common/controls/select2', 'utils/search/filterSearch'], (Select2, filterSearch) =>

    /*
     * Can be used for all collections, which have id and name fields
     * TODO: rename to entityselect2
     */
    Select2.extend({

        formatSelection (state) {
            return '#{0} {1}'.format(state.id, _.escape(state.name));
        },

        formatResult (state) {
            return '#{0} {1}'.format(state.id, _.escape(state.name));
        },

        matcher (term, text, option) {
            const filteredTerm = filterSearch.default(term);
            return option.name.toUpperCase().indexOf(filteredTerm.toUpperCase()) >= 0 ||
              `${option.id}`.indexOf(filteredTerm) >= 0;
        }

    })

);
